import React from "react";
import "./AppContent.css";

export default ({ children }) => <div className="AppContent">{children}</div>;



// WEBPACK FOOTER //
// ./src/components/AppContent.js